import React from 'react';
import { useHistory } from 'react-router-dom';
import { Card, CardBody, CardTitle, CardText, Badge } from 'reactstrap';
import { Users, Globe } from 'lucide-react';
import { FEATURE_FLAGS, isFeatureEnabled } from '../../config/featureFlags';

const GroupCard = ({ group }) => {
    const bitcoinEnabled = isFeatureEnabled(FEATURE_FLAGS.bitcoinExperience);
  const history = useHistory();

  const handleCardClick = () => {
    history.push(`/group/${group.id}`);
  };
  const thumbnail = group.thumbnailUrl || group.profilePictureUrl;
  const initials = (group.groupName || 'Community')
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase();

  return (
    <Card
      onClick={handleCardClick}
      className="group-card bg-gray-900 text-white shadow-lg rounded-lg cursor-pointer hover:shadow-xl transition-all duration-300 border border-gray-700"
    >
      <div className="group-card-identity">
        <div className="group-card-thumbnail" aria-hidden={!thumbnail}>
          {thumbnail
            ? <img src={thumbnail} alt={`${group.groupName || 'Community'} thumbnail`} />
            : <span>{initials}</span>}
        </div>
        <div className="group-card-copy p-4 flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-bold text-yellow-400 truncate">{group.groupName}</h3>
          <Badge color="warning" className="text-olive bg-yellow-400">{group.groupCategory}</Badge>
        </div>

        <CardText className="text-sm text-gray-300 line-clamp-3">
          <strong>Mission:</strong> {group.groupMission || 'No mission provided.'}
        </CardText>

        <div className="text-sm text-gray-400 flex flex-wrap gap-2">
          <span><Globe size={16} className="inline-block me-1" /> {group.city || 'Unknown City'}, {group.state}</span>
          <span><Users size={16} className="inline-block me-1" /> {group.subscriptions ?? group.Subscriptions ?? 0} members</span>
        </div>

        <div className="text-sm flex flex-wrap gap-3 mt-2">
          <span className="bg-gray-800 rounded px-2 py-1 text-yellow-300">
            Eligible: {group.eligibleTo || 'Unknown'}
          </span>
          {bitcoinEnabled && <span className="bg-gray-800 rounded px-2 py-1 text-green-300">
            Dues: {group.monthlyDues || 0} BTC
          </span>}
          {bitcoinEnabled && <span className="bg-gray-800 rounded px-2 py-1 text-blue-300">
            Dividends: {group.monthlyDividends || 0} BTC
          </span>}
        </div>
        </div>
      </div>
    </Card>
  );
};

export default GroupCard;
